import i18nFactory from '@yandex-int/i18n';

import { LogHelpers } from '../../../service/LogHelpers/LogHelpers';
import { RestrictFrequencyFragment } from '../../../typings/graphql-log';
import { RestrictFrequencyGroups } from '../../../typings/log';

import * as keyset from './restrictfrequency.i18n';

const i18n = i18nFactory(keyset);

export function prepareRestrictFrequency(
    before?: RestrictFrequencyFragment,
    after?: RestrictFrequencyFragment
): RestrictFrequencyGroups {
    if (!before || !after) {
        throw Error('Некорректное значение для настроек ограничения показов: нет данных');
    }

    const maxLineLength = calcRestrictFrequencyMaxLineLength(before, after);

    return {
        before: before,
        after: after,
        needExpand: LogHelpers.calcNotAlwaysNeedExpand(maxLineLength),
        maxLineLength: maxLineLength,
        alwaysNeedExpand: false
    };
}

function calcRestrictFrequencyMaxLineLength(
    before: RestrictFrequencyFragment,
    after: RestrictFrequencyFragment
): number {
    let showsSettingText, daysSettingText;

    const beforeReset = before.reset || i18n('company-period-time');
    const afterReset = after.reset || i18n('company-period-time');

    if (before.value === 0 && after.value !== 0) {
        showsSettingText = i18n('shows-setting', {
            limit: after.value
        });
        daysSettingText = i18n('days-setting', { limit: afterReset });
    } else if (before.value !== 0 && after.value === 0) {
        showsSettingText = i18n('shows-setting', {
            limit: before.value
        });
        daysSettingText = i18n('days-setting', { limit: beforeReset });
    } else {
        showsSettingText =
            before.value === after.value
                ? i18n('shows-setting', {
                      limit: before.value
                  })
                : i18n('shows-setting-changed', {
                      oldLimit: before.value,
                      newLimit: after.value
                  });

        daysSettingText =
            afterReset === beforeReset
                ? i18n('days-setting', {
                      limit: beforeReset
                  })
                : i18n('days-setting-changed', {
                      oldLimit: beforeReset,
                      newLimit: afterReset
                  });
    }

    return Math.max(showsSettingText.length, daysSettingText.length);
}
